import React, { FunctionComponent } from 'react';
import { get } from 'lodash';
import {
  Wrapper,
  Title,
  RoomPreviewWrapper,
  RoomPreviewImg,
  RoomPreviewDescription,
  RoomPreviewImgWrapper,
  OptionList,
  StyledMeal,
  StyledPlane,
  StyledBus,
  StyledInsurance,
  StyledLink,
} from './PackageInfoBlock.style';
import { PackageContextState } from '../../types';
import { useGetPackageData, useGetLinkToPackage } from '../../hooks';
import { useConstructorContextState } from '../../../../context/constructorContext';

// TODO:
type Props = {
  className?: string;
  roomInfo: PackageContextState['package']['room_info'];
  hotelPreview?: string;
  meal?: string;
  mealCode?: string;
  mealOriginal?: string;
  transfer?: boolean;
  medicalInsurance?: boolean;
  isHotelOnly: boolean;
};

export const PackageInfoBlock: FunctionComponent<Props> = ({
  className,
  roomInfo,
  hotelPreview,
  transfer,
  medicalInsurance,
  isHotelOnly,
}) => {
  const image = get(roomInfo, ['images', '0', 'x100x110'], hotelPreview);
  const { packageData } = useGetPackageData();
  const configState = useConstructorContextState();
  const { linkToPackage } = useGetLinkToPackage();

  return (
    <Wrapper className={className}>
      <Title>
        {packageData?.search_type === 'hotel'
          ? 'В стоимость проживания входит'
          : 'В стоимость тура входит'}
      </Title>

      <RoomPreviewWrapper>
        {image && (
          <RoomPreviewImgWrapper>
            <RoomPreviewImg src={image} />
          </RoomPreviewImgWrapper>
        )}
        {roomInfo.name_ru && <RoomPreviewDescription>{roomInfo.name_ru}</RoomPreviewDescription>}
      </RoomPreviewWrapper>
      <OptionList>
        <StyledMeal />
        {!isHotelOnly && <StyledPlane />}
        {transfer && <StyledBus />}
        {medicalInsurance && <StyledInsurance />}
        <StyledLink href={linkToPackage} target={configState.redirect}>
          Подробнее
        </StyledLink>
      </OptionList>
    </Wrapper>
  );
};
